var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FormSubmitPopup", {
    ref: "formPopup",
    attrs: {
      title: _vm.title,
      rightMethod: _vm.onSubmitted,
      rightButtonText: _vm.$t("submit"),
      large: ""
    },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            _c(
              "v-container",
              [
                _c(
                  "v-card",
                  [
                    _c("v-card-title", [
                      _c("h3", [_vm._v(_vm._s(_vm.$t("unitCLbHint")))])
                    ]),
                    _vm._v(" "),
                    _c(
                      "v-card-text",
                      { staticClass: "pb-0" },
                      [
                        _c(
                          "v-list",
                          [
                            _vm._l(_vm.weightScope, function(scope, index) {
                              return _c(
                                "div",
                                { key: index },
                                [
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c(
                                        "v-layout",
                                        [
                                          _c("v-text-field", {
                                            staticClass: "required_field",
                                            attrs: {
                                              rules: [
                                                _vm.getScopeValidator(
                                                  "start",
                                                  _vm.weightScope,
                                                  Number(index),
                                                  0
                                                )
                                              ],
                                              disabled:
                                                index !==
                                                _vm.weightScope.length - 1,
                                              label:
                                                _vm.$t("start") + "('weight')"
                                            },
                                            model: {
                                              value: scope.start,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  scope,
                                                  "start",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression: "scope.start"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: { "pt-3": "", "px-2": "" }
                                            },
                                            [_c("span", [_vm._v("< X ≤")])]
                                          ),
                                          _vm._v(" "),
                                          _c("v-text-field", {
                                            staticClass: "required_field",
                                            staticStyle: { width: "167px" },
                                            attrs: {
                                              rules: [
                                                _vm.getScopeValidator(
                                                  "end",
                                                  _vm.weightScope,
                                                  Number(index),
                                                  1
                                                )
                                              ],
                                              name: "end",
                                              disabled:
                                                index !==
                                                _vm.weightScope.length - 1,
                                              label:
                                                _vm.$t("end") + "('weight')"
                                            },
                                            model: {
                                              value: scope.end,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  scope,
                                                  "end",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression: "scope.end"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("v-text-field", {
                                            staticClass: "required_field pl-2",
                                            attrs: {
                                              label: _vm.$t("price"),
                                              prefix: "$",
                                              rules: [
                                                _vm.fieldIsRequired(),
                                                _vm.fieldIsNoLessThanZero(),
                                                _vm.fieldIsNumber()
                                              ]
                                            },
                                            model: {
                                              value: scope.price,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  scope,
                                                  "price",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression: "scope.price"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("v-text-field", {
                                            staticClass: "required_field pl-2",
                                            attrs: {
                                              label: _vm.$t("secondItemPrice"),
                                              prefix: "$",
                                              rules: [
                                                _vm.fieldIsRequired(),
                                                _vm.fieldIsNoLessThanZero(),
                                                _vm.fieldIsNumber()
                                              ]
                                            },
                                            model: {
                                              value: scope.secondItemPrice,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  scope,
                                                  "secondItemPrice",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression:
                                                "scope.secondItemPrice"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _vm.feeType === "outbound"
                                            ? _c("v-text-field", {
                                                staticClass:
                                                  "required_field pl-2",
                                                attrs: {
                                                  label: _vm.$t(
                                                    "subsequentUPCFirstPrice"
                                                  ),
                                                  prefix: "$",
                                                  rules: [
                                                    _vm.fieldIsRequired(),
                                                    _vm.fieldIsNoLessThanZero(),
                                                    _vm.fieldIsNumber()
                                                  ]
                                                },
                                                model: {
                                                  value:
                                                    scope.secondProductPrice,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      scope,
                                                      "secondProductPrice",
                                                      _vm._n($$v)
                                                    )
                                                  },
                                                  expression:
                                                    "scope.secondProductPrice"
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            { staticClass: "text-xs-right" },
                                            [
                                              index ===
                                                _vm.weightScope.length - 1 &&
                                              index > 0
                                                ? _c(
                                                    "v-btn",
                                                    {
                                                      attrs: { icon: "" },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.removeScope(
                                                            index
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v("delete")
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            _vm._v(" "),
                            _vm.weightScope.length > 0
                              ? _c(
                                  "v-layout",
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { md4: "" } },
                                      [
                                        _c("v-text-field", {
                                          staticClass: "required_field",
                                          attrs: {
                                            label: _vm.$t(
                                              "overSizeChargePrice"
                                            ),
                                            prefix: "$",
                                            rules: [
                                              _vm.fieldIsRequired(),
                                              _vm.fieldIsNoLessThanZero(),
                                              _vm.fieldIsNumber()
                                            ]
                                          },
                                          model: {
                                            value:
                                              _vm.weightScope[
                                                _vm.weightScope.length - 1
                                              ].overSizeChargePrice,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.weightScope[
                                                  _vm.weightScope.length - 1
                                                ],
                                                "overSizeChargePrice",
                                                _vm._n($$v)
                                              )
                                            },
                                            expression:
                                              "weightScope[weightScope.length - 1].overSizeChargePrice"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          2
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-card-actions",
                      [
                        _c(
                          "v-layout",
                          [
                            _c(
                              "v-flex",
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { color: "primary" },
                                    on: {
                                      click: function($event) {
                                        return _vm.addScope(_vm.weightScope)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("add")))]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-539f6f6c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-539f6f6c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WeightFeeSettingPopup.vue
// module id = null
// module chunks = 